import Faq from 'pages/Faq';
import Home from 'pages/Home';
import { paths } from 'config';
import Contact from 'pages/Contact';
import Layout from 'components/Layout';
import AgendarCita from 'pages/AgendarCita';
import HistorialCitas from 'pages/HistorialCitas';
import ConsultaMedicamentos from 'pages/ConsultaMedicamentos';
import ExamenesLaboratorio from 'pages/ExamenesLaboratorio';
import CitasMedicas from 'pages/CitasMedicas';
import ReportePDF from 'pages/ReportePDF';
import VerificarReferencia from 'pages/VerificarReferencia';
import {
	BrowserRouter,
	Navigate,
	Routes,
	Route,
	useParams,
} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import ErrorBoundary from 'components/ErrorBoundary';

const ReportePublico = () => {
	const { id, token } = useParams<Record<string, string | undefined>>();

	if (id === '2' && token) {
		const verificationPath = paths.verificar_referencia.replace(
			':token',
			encodeURIComponent(token)
		);
		return <Navigate replace to={verificationPath} />;
	}

	return <ReportePDF />;
};

const pages = [
	{ path: paths.faq, Element: Faq },
	{ path: paths.home, Element: Home },
	{ path: paths.contact, Element: Contact },
	{ path: paths.agendar_cita, Element: AgendarCita },
	{ path: paths.consultar_medicamentos, Element: ConsultaMedicamentos },
	{ path: paths.historial_citas, Element: HistorialCitas },
	{ path: paths.citas_medicas, Element: CitasMedicas },
	{ path: paths.examenes_laboratorio, Element: ExamenesLaboratorio },
	{ path: paths.reporte_pdf, Element: ReportePublico },
	{ path: paths.verificar_referencia, Element: VerificarReferencia },
];

function App() {
	return (
		<ConfigProvider locale={esES}>
			<BrowserRouter>
				<Layout>
					<ErrorBoundary>
						<Routes>
							{pages.map(({ path, Element }, index) => (
								<Route key={index} path={path} element={<Element />} />
							))}
						</Routes>
					</ErrorBoundary>
				</Layout>
			</BrowserRouter>
		</ConfigProvider>
	);
}

export default App;
